<template>
  <section class="address">
    <span class="address-location"></span>
    <p>{{info.name}} <span>{{account.mobile}}</span></p>
    <p>{{info.city}} {{info.address}}</p>
  </section>
</template>

<script>
export default {
  computed: {
    info() {
      return this.$store.state.user.info;
    },
    account() {
      return this.$store.state.account.user;
    }
  }
};
</script>

<style scoped>
.address {
  width: 3.49rem;
  margin: 0.16rem auto 0rem;
  box-shadow:0rem 0rem 0.04rem rgba(134,130,130,0.3);
    background: #fff;
  padding: 0.18rem 0.17rem 0.18rem 0.6rem;
  border-radius: 0.05rem;
  position: relative;
}
.address p {
  color: #333;
  font-size: 0.15rem;
}
.address p span{color: #999;font-size: 0.14rem;}
.address p:nth-child(3){font-size: 0.14rem;margin-top: 0.14rem;}
.address-location {
  position: absolute;
  left: 0.17rem;
  top: 0.24rem;
  width: 0.3rem;
  height: 0.3rem;
  background: url(../../../assets/image/position.png) no-repeat;
  background-size: 100%;
}
</style>
